import { render, staticRenderFns } from "./wordsListModal.vue?vue&type=template&id=65f7f48c&scoped=true&"
import script from "./wordsListModal.vue?vue&type=script&lang=js&"
export * from "./wordsListModal.vue?vue&type=script&lang=js&"
import style0 from "./wordsListModal.vue?vue&type=style&index=0&id=65f7f48c&lang=less&scoped=true&"
import style1 from "./wordsListModal.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7f48c",
  null
  
)

export default component.exports